import { useQuery } from '@apollo/client';
import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { EventTypes, OrgTypes } from '../store/actions';
import REGIONAL_DIRECTORS_QUERY from '../events/queries/REGIONAL_DIRECTORS_QUERY';
import { AppContext } from '../store';

export interface IRegionalDirector {
    lookup_id: string;
    first_name: string;
    last_name: string;
    phone: string;
    group: number
    name: string;
    event_coordinator: string;
    event_coordinator_email: string;
}
interface RDProps {
    onChange?: Function,
}
const RDSelector = ({ onChange }: RDProps) => {
    const { state, dispatch } = useContext(AppContext);
    const [rdList, setRdList] = useState<IRegionalDirector[]>();
    const isEC = state.orgInfo?.event_coordinator;
    useQuery(REGIONAL_DIRECTORS_QUERY, {
        fetchPolicy: "no-cache",
        onCompleted: (data: any) => {
            setRdList(data.regionalDirectors);
        }
    });
    const rdValue = state.orgInfo?.emulated_lookup_id || state.eventInfo.currentOrder?.stakeholders?.filter(s => s.role === 'RD')[0]?.lookupId || state.eventInfo.currentEvent?.stakeholders?.filter(s => s.role === 'RD')[0]?.lookupId;
    useEffect(() => {
        if (rdValue && !state.orgInfo.emulated_lookup_id) {
            dispatch({
                type: OrgTypes.setProfile,
                payload: { ...state.orgInfo, emulated_lookup_id: rdValue },
            });
        }
    },[rdValue, dispatch, state.orgInfo]);
    if (isEC) {
        return <>
            <Form.Control as="select" value={rdValue} onChange={(event: ChangeEvent<any>) => {
                const lookupId: string = event.target.value || '';

                dispatch({
                    type: OrgTypes.setProfile,
                    payload: { ...state.orgInfo, emulated_lookup_id: lookupId },
                });
                dispatch({
                    type: EventTypes.SetOrders,
                    payload: { ...state.eventInfo, currentEvent: null, currentOrder: null, loaded: false, },
                });
                if (onChange) {
                    onChange();
                }
            }}>
                <option>{rdList ? '--- Select One ---' : 'Loading ...'}</option>
                {rdList && rdList.map(rd => <option key={rd.lookup_id} value={rd.lookup_id}>{rd.name}</option>)}
            </Form.Control>
        </>
    }
    return null;
};

export default RDSelector;
